module.exports = __webpack_public_path__ + "img/balance.08dc3438.png";